import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React from 'react';
import { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { FieldContainer, Field, Label, FieldBefore } from '../field';
import { Icon } from '../icon';
import { useFieldValidation } from '../../hooks/validation-field';
import { makeSelect, makeCustomSup } from './mixins';
import { Helper } from '../Helper';
var SelectField = styled(CreatableSelect)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeSelect(props);
});
var CustomSup = styled.sup(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function () {
  return makeCustomSup();
});

var DropdownIndicator = function DropdownIndicator(props) {
  var hasValue = props.hasValue,
      selectProps = props.selectProps;
  return (!selectProps.isClearable || selectProps.isClearable && !hasValue) && React.createElement(components.DropdownIndicator, Object.assign({}, props), React.createElement(Icon, {
    name: "icon-light-caret-down",
    color: "rgba(0, 0, 24, 0.16)",
    size: "16"
  }));
};

var ClearIndicator = function ClearIndicator(props) {
  return React.createElement(components.ClearIndicator, Object.assign({}, props), React.createElement(Icon, {
    name: "icon-light-close",
    color: "rgba(0, 0, 24, 0.16)",
    size: "16"
  }));
};

export var DataList = function DataList(_ref) {
  var options = _ref.options,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Seleccione una opción' : _ref$placeholder,
      name = _ref.name,
      id = _ref.id,
      _onChange = _ref.onChange,
      _onBlur = _ref.onBlur,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      rules = _ref.rules,
      errors = _ref.errors,
      control = _ref.control,
      fieldOptions = _ref.fieldOptions,
      reactSelectOptions = _ref.reactSelectOptions,
      noBottomMargin = _ref.noBottomMargin;

  var _useFieldValidation = useFieldValidation(rules, errors, name, disabled),
      fieldStates = _useFieldValidation.fieldStates,
      classes = _useFieldValidation.classes,
      setValue = _useFieldValidation.setValue,
      setActive = _useFieldValidation.setActive;

  var handleOnChange = function handleOnChange(option, callback) {
    setValue(option);
    callback && callback(name, option);
  };

  var handleOnBlur = function handleOnBlur(event, callback) {
    setActive(false);
    callback && callback(event);
  };
  /**
   * Quita el listado de opciones en caso que el select se encuentre desabilitado o en caso
   * de contar con la opcion isClearable en true y un valor definido
   */


  var removeMenu = disabled || reactSelectOptions && reactSelectOptions.isClearable && value;
  return React.createElement(FieldContainer, null, fieldOptions && fieldOptions.label && React.createElement(Label, {
    htmlFor: id || "select-".concat(name)
  }, fieldOptions.label, rules && rules.required && React.createElement(CustomSup, null, "*")), React.createElement(Field, Object.assign({}, fieldOptions, {
    states: Object.assign({}, fieldStates),
    className: classes
  }), fieldOptions && fieldOptions.before && React.createElement(FieldBefore, null, fieldOptions.before), rules ? React.createElement(Controller, Object.assign({
    as: React.createElement(SelectField, Object.assign({
      createOptionPosition: "first",
      formatCreateLabel: function formatCreateLabel(inputValue) {
        return inputValue;
      },
      id: id || "select-".concat(name),
      placeholder: placeholder,
      options: options,
      isDisabled: disabled
    }, removeMenu && {
      menuIsOpen: false
    }, {
      onMenuOpen: function onMenuOpen() {
        return setActive(true);
      },
      onBlur: function onBlur(event) {
        return handleOnBlur(event, _onBlur);
      }
    }, fieldOptions, reactSelectOptions, {
      components: {
        DropdownIndicator: DropdownIndicator,
        ClearIndicator: ClearIndicator
      },
      classNamePrefix: "select"
    })),
    defaultValue: value
  }, {
    control: control,
    rules: rules
  }, {
    onChange: function onChange(_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          selected = _ref3[0];

      handleOnChange(selected, _onChange);
      return selected;
    },
    name: name
  })) : React.createElement(SelectField, Object.assign({
    name: name,
    id: id || "select-".concat(name),
    placeholder: placeholder,
    options: options,
    isDisabled: disabled
  }, removeMenu && {
    menuIsOpen: false
  }, {
    onChange: function onChange(option) {
      return handleOnChange(option, _onChange);
    },
    onMenuOpen: function onMenuOpen() {
      return setActive(true);
    },
    onBlur: function onBlur() {
      return setActive(false);
    }
  }, fieldOptions, reactSelectOptions, {
    value: value,
    defaultValue: defaultValue,
    components: {
      DropdownIndicator: DropdownIndicator,
      ClearIndicator: ClearIndicator
    },
    classNamePrefix: "select"
  }))), React.createElement(Helper, {
    name: name,
    fieldOptions: fieldOptions,
    errors: errors,
    noBottomMargin: noBottomMargin
  }));
};